export const SESSION_REFRESH_LOCK = 'tagdada-session-refresh';

/**
 * Serialize refresh ownership across same-origin tabs when the browser supports
 * Web Locks. Older browsers still receive the per-tab single-flight guarantee.
 */
export function withBrowserSessionRefreshLock(task) {
  const locks = typeof navigator !== 'undefined' ? navigator.locks : null;
  if (locks && typeof locks.request === 'function') {
    return locks.request(SESSION_REFRESH_LOCK, task);
  }
  return task();
}

/**
 * A session refresh is one logical operation, even when many API requests fail
 * together. `probe` runs inside the cross-tab lock so a waiting tab can observe
 * cookies installed by the tab that refreshed first and avoid replaying the
 * single-use refresh credential.
 */
export function createSessionRefreshCoordinator({
  probe,
  refresh,
  runExclusive = withBrowserSessionRefreshLock,
}) {
  let inFlight = null;

  const ensureFresh = () => {
    if (inFlight) return inFlight;

    const operation = Promise.resolve().then(() => runExclusive(async () => {
      if (await probe()) return { refreshed: false };
      await refresh();
      return { refreshed: true };
    }));

    const shared = operation.finally(() => {
      if (inFlight === shared) inFlight = null;
    });
    inFlight = shared;
    return shared;
  };

  return { ensureFresh };
}

